"use strict";

var _classCallCheck = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createClass.js").default;
var _inherits = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createSuper.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LongSizeCSSPropertyValidator = void 0;
var _LongCSSPropertyValidator = require("./LongCSSPropertyValidator");
var LongSizeCSSPropertyValidator = /*#__PURE__*/function (_LongCSSPropertyValid) {
  _inherits(LongSizeCSSPropertyValidator, _LongCSSPropertyValid);
  var _super = _createSuper(LongSizeCSSPropertyValidator);
  function LongSizeCSSPropertyValidator() {
    _classCallCheck(this, LongSizeCSSPropertyValidator);
    return _super.apply(this, arguments);
  }
  _createClass(LongSizeCSSPropertyValidator, [{
    key: "computeSize",
    value: function computeSize(value, unit) {
      switch (unit) {
        case '%':
          return "".concat(value, "%");
        case 'px':
          return value;
        case 'cm':
        case 'in':
        case 'mm':
        case 'pc':
        case 'pt':
          return value * this.config.absoluteLengthUnitsMultiplicators[unit];
        case 'em':
          return this.computeEmSize(value);
        case 'ex':
          // This is an approximation.
          return this.computeEmSize(value * 0.63);
        case 'rem':
          return this.config.rootFontSize * value;
      }
      return null;
    }
  }, {
    key: "computeEmSize",
    value: function computeEmSize(value) {
      return this.config.rootFontSize * value;
    }
  }, {
    key: "splitValueAndUnit",
    value: function splitValueAndUnit(value) {
      var match = /^(\d*\.?\d*)\s*(cm|mm|in|px|pt|pc|em|ex|ch|rem|vw|vh|vmin|vmax|%)$/g.exec(value);
      if (match === null) {
        return null;
      }
      return [Number(match[1]), match[2]];
    }
  }, {
    key: "normalizeRawInlineCSSValue",
    value: function normalizeRawInlineCSSValue(value) {
      if (value === '0') {
        return 0;
      }
      if (value === 'auto') {
        return value;
      }
      var split = this.splitValueAndUnit(value);
      if (split) {
        return this.computeSize(split[0], split[1]);
      }
      return null;
    }
  }, {
    key: "normalizeNativeValue",
    value: function normalizeNativeValue(value) {
      return this.normalizeInlineCSSValue(value);
    }
  }]);
  return LongSizeCSSPropertyValidator;
}(_LongCSSPropertyValidator.LongCSSPropertyValidator);
exports.LongSizeCSSPropertyValidator = LongSizeCSSPropertyValidator;